// extracted by mini-css-extract-plugin
module.exports = {"feed":"FeedPhotos_feed__3gL7G"};